import ebayLogoMini from '@/assets/images/logos/ebay-mini.svg'
import whatnotLogoMini from '@/assets/images/logos/whatnot-mini.svg'
import collxLogoMini from '@/assets/images/logos/collx-mini.svg'
import shopifyLogoMini from '@/assets/images/logos/shopify-mini.svg'
import mySlabsLogoMini from '@/assets/images/logos/my-slabs-mini.svg'
import dripLogoMini from '@/assets/images/logos/drip-mini.svg'
import instagramLogoMini from '@/assets/images/logos/instagram-mini.svg'
import facebookLogoMini from '@/assets/images/logos/facebook-mini.svg'
import tcgPlayerLogoMini from '@/assets/images/logos/tcg-player-mini.svg'

export const TOTAL_CARDS_OPTIONS = [
  '0-500',
  '500-1,000',
  '1,000-10,000',
  '10,000-25,000',
  '25,000-50,000',
  '50,000+',
]

export const TEAM_MEMBERS_OPTIONS = [ '1', '1-5', '5-10', '10-20', '20+' ]

export const CDP_HEAR_OPTIONS = [
  'The Card Life Commercial',
  'Facebook/Instagram Ads',
  'Google Search Ads',
  'Organic Google/Bing Search',
  'Jmac Sports Cards',
  'Ball Card Genius',
  'Beau from One Million Cubs',
  'Organic Social Media Posts',
  'Card Show/Conference',
  'Friends/Family',
  'Existing CDP Customer',
  'Other (enter below)',
]

export const HAVE_SCANNER_OPTIONS = [ 'Yes', 'No' ]

export const CAPTURE_OPTIONS = [
  'Phone camera',
  'Other camera (DSLR, etc.)',
  'I’ll buy a scanner later',
  'Other (enter below)',
]

export const OPERATING_SYSTEM_OPTIONS = [ 'Mac', 'Windows', 'Chrome OS' ]

export const MARKETPLACES_OPTIONS = [
  {
    id: 1,
    logo: ebayLogoMini,
    name: 'eBay',
    key: 'ebay',
  },
  {
    id: 2,
    logo: whatnotLogoMini,
    name: 'Whatnot',
    key: 'whatnot',
  },
  {
    id: 3,
    logo: collxLogoMini,
    name: 'CollX',
    key: 'collx',
  },
  {
    id: 4,
    logo: shopifyLogoMini,
    name: 'Shopify',
    key: 'shopify',
  },
  {
    id: 5,
    logo: mySlabsLogoMini,
    name: 'MySlabs',
    key: 'my-slabs',
  },
  {
    id: 6,
    logo: dripLogoMini,
    name: 'Drip',
    key: 'drip',
  },
  {
    id: 7,
    logo: instagramLogoMini,
    name: 'Instagram',
    key: 'instagram',
  },
  {
    id: 8,
    logo: facebookLogoMini,
    name: 'Facebook',
    key: 'facebook',
  },
  {
    id: 9,
    logo: tcgPlayerLogoMini,
    name: 'TCGPlayer',
    key: 'tcgplayer',
  },
  {
    id: 10,
    logo: null,
    name: 'Other',
    key: 'other',
  }
]

// Getting Started task keys: the contract with the `tasks` Strapi holds on each step. A dealer's progress is stored
// against them in `data.about.onboarding`, so a key is never renamed once live — a renamed key reads as not done.
export const ONBOARDING_TASK = {
  BATCH_CREATED: 'batch-created',
  IMPORT_COMPLETED: 'import-completed',
  CARDS_REVIEWED: 'cards-reviewed',
  CARD_LISTED: 'card-listed',
  ORDERS_VIEWED: 'orders-viewed',
  PICK_LIST_CREATED: 'pick-list-created',
  TITLE_DESCRIPTION_TEMPLATES: 'title-description-templates',
}

// The marketplaces with a connect task (`connect-ebay`) and a settings task (`ebay-settings`) each.
export const ONBOARDING_MARKETPLACES = ['ebay', 'collx', 'shopify', 'whatnot']

export const onboardingConnectTask = (marketplace) => `connect-${marketplace}`
export const onboardingSettingsTask = (marketplace) => `${marketplace}-settings`

// How a task came to be done: seen as it happened, or read off what the dealer already has. `manual` is a whole step
// the dealer marked complete by hand (`completed[stepKey]`); its tasks are left as they are.
export const ONBOARDING_SOURCE = {
  AUTO: 'auto',
  RECORD: 'record',
  MANUAL: 'manual',
}

export const ONBOARDING_STEP_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
}
